export const generalEn = {
  strTarefa: 'Task',
  strInsumo: 'Input',
  strQueProcura: 'What are you looking for?',
  strCod: 'code',
  strMoeda: 'coin',
  strContracts: 'contracts payable',
  strTotal: 'Total',
  strContratado: 'Hired',
  strPago: 'paid out',
  strLiberado: 'Released',
  strSaldo: 'Balance',
  strSaldoAPagar: 'Balance to pay',
  strSelecionarProjeto: 'Project',
  strSelecionarColigada: 'Select the company',
  strSelectProjeto: 'Select the project',
  strColigadaProjetoObrigatorios: 'Company and Project are mandatory.',
  strSalvar: 'Save',
  strCancelar: 'Cancel',
  strUsuarioSemPermissaoFuncionalidade: 'You are not allowed to access the Task / Input Cockpit in the company',
  strNenhumRegistroEncontrado: 'Not found.',
  strVerificandoPermissao: 'Checking permission',
  strVejaMais: 'See More',
  strPlaceHolderMultiSelectTaskInput: 'Filter by cost group',
  strQuantidade: 'Amount',
  strValor: 'Value',
  strUnidade: 'unity',
  strSaldoInsumo: 'Balance = Budgeted - (Order + Contracted)',
  strSaldoInsumoTarefa: 'Balance = Budgeted - (Order + Measured)',
  strMedido: 'Measured',
  strOrcado: 'Budgeted',
  strApropriado: 'Appropriate',
  strPedido: 'Request',
  strPedidos: 'Requests',
  strEntregue: 'Delivered',
  strTarefas: 'Tasks',
  strInsumos: 'Inputs',
  strInputTaskLabelDisclaimer: 'Task Code or Description',
  strPlanejado: 'Planned',
  strCusto: 'Cost',
  strConfigHost: 'It is necessary to define the server address in the file {0}, current configuration {1}, this configuration will make it possible to use the cockpit only on the installed server.',
  strPlaceHolderInputTask: 'Do you want to view specific tasks? Enter the code, name, description or parts of the code, name or description here.',
  strStatus: 'status',
  strTarefaFinalizada: 'of the completed task',
  strProjetoAtual: 'Your current project',
  strUltimaImportacaoBackOffice: 'Last Import of Moves from BackOffice',
  strUltimoCalculoProjeto: 'Last Project Calculation',
  strUsuario: 'User',
  strTituloTotvs: 'PORTAL TOTVS CONSTRUCTION WORKS & PROJECTS',
  strTrocarProjeto: 'Change project',
  strSair: 'Logout',
  strPedidoExtra: 'extra order',
  strMedicoes : 'measurements',
  strAtualizar: 'Update',
  strCodTarefa: 'Task Code',
  strNome: 'Name',
  strDescricao: 'Description',
  strPortugues:'Português',
  strEspanhol:'Español',
  strIngles:'English',
  strTarefaNaoEncontrada:'Task not found.'
};

